import { render, staticRenderFns } from "./proposal-preview-section.vue?vue&type=template&id=060b9f3d"
import script from "./proposal-preview-section.vue?vue&type=script&lang=js"
export * from "./proposal-preview-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports